module.exports = __webpack_public_path__ + "static/img/4.4723f9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/logos/4.svg
// module id = 699
// module chunks = 1